import { render, staticRenderFns } from "./bi-claim-list.vue?vue&type=template&id=3dc53c12&"
import script from "./bi-claim-list.vue?vue&type=script&lang=ts&"
export * from "./bi-claim-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports